import axios from 'axios';
import { API_BASE_URL } from './api';
import type { ProductImage } from '../types/product';

const getAuthHeader = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const productImageService = {
  getAll: async (productId: number): Promise<ProductImage[]> => {
    const response = await axios.get(`${API_BASE_URL}/products/${productId}/images`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  upload: async (productId: number, file: File): Promise<ProductImage> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`${API_BASE_URL}/products/${productId}/images`, formData, {
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  setMain: async (imageId: number): Promise<void> => {
    await axios.put(`${API_BASE_URL}/images/${imageId}/main`, {}, {
      headers: getAuthHeader(),
    });
  },

  delete: async (imageId: number): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/images/${imageId}`, {
      headers: getAuthHeader(),
    });
  },
};
